<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import channelApi from "./api/channel";
import { format } from "./utils/time";
import watermark from "./utils/watermark";
import { mapState } from 'vuex'
import Cookies from 'js-cookie'

export default {
  computed: {
    ...mapState('user', ['vertifyState'])
  },
  watch: {
    vertifyState(val) {
      if(val) {
        this.setWaterMark()
      }
    }
  },
  methods: {
    async setWaterMark() {
      try {
        let channelRes = await channelApi.topup.getChannels();
        let list = channelRes.channel_list || [];

        // 获取所有api_list并合并到一个数组
        const allApiList = [...new Set(
          list.reduce((acc, channel) => {
            if (channel.api_list && Array.isArray(channel.api_list)) {
              acc.push(...channel.api_list);
            }
            return acc;
          }, [])
        )];
        // getChannelInfo
        this.$store.commit("user/SET_CHANNEL_INFO", list);
        this.$store.commit("user/SET_API_LIST", allApiList);
        let userChannel =
          list.length > 0
            ? `${list[0].channel_id} (${list[0].channel_name})`
            : "";
        await watermark(this.$store.state.user.nickName, {
          channel: userChannel,
          time: format(new Date(), "yyyy-MM-dd HH:mm:ss"),
          color: "#9BA9Bc",
        }).then((data) => {
          const css = `
              html,
              .watermark-bg {
                background-image: url(${data});
              }
            `;
          const style = document.createElement("style");
          style.innerHTML = css;
          document.head.appendChild(style);
          const div = document.createElement("div");
          div.className = "watermark-bg watermark-full-shade";
          document.body.appendChild(div);
        })
        .catch(err => {
          console.error('生成水印失败:', err);
          // 可以选择添加默认水印或忽略错误
        });
      } catch (err) {
        console.error('设置水印过程中发生错误:', err);
        // 可以在这里添加错误上报逻辑
      }
    },
  },
  async mounted() {
    if(Cookies.get('verify_phone_code')) {
      await this.setWaterMark();
      // 确保权限数据加载完成
      this.$nextTick(() => {
        if (this.$route.path === '/' && this.$router) {
          this.$router.replace(this.$route.path);
        }
      })
    }
  }
};
</script>
